import { PlannerValidation, ProductType } from '@inter-ikea-storageone/range';
import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import BestaOpeningFunctionComponent from '../components/BestaOpeningFunctionComponent';
/**
 * Don't allow handles on push-to-open drawers
 */
export class HandleOnDrawerValidation extends PlannerValidation {
    constructor(coreApi) {
        super(coreApi, 'HandleOnDrawerValidation');
    }
    validateCurrentState() {
        return this.validationOK();
    }
    validateSnap(snapActionCandidate) {
        const entity = snapActionCandidate.guestRoot;
        if (entity.hasComponent(ComponentIds.HANDLE_COMPONENT_ID) &&
            HierarchyUtils.findWithComponentInUpwardsHierarchy(snapActionCandidate.host, ComponentIds.DRAWER_COMPONENT_ID)?.getComponent(BestaOpeningFunctionComponent.id)
                ?.openingFunction === ProductType.BESTA_PUSH_OPEN) {
            return this.validationFail('Cant add handles to push-to-open drawer');
        }
        return this.validationOK();
    }
}
//# sourceMappingURL=HandleOnDrawerValidation.js.map